export const SCREEN_TYPE_CONSTANTS = {
  CANCELED: 'canceled',
  REJECTED: 'rejected',
  CONGRATULATIONS: 'congratulations',
};
